













import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import {modalTemplate} from '@/components/common/types';

/* tslint:disable:no-console */
/* tslint:disable:no-empty */

@Component({
    components: {},
})
export default class ModalTemplate extends modalTemplate {
    @Prop() public readonly showLogo: boolean | undefined;
    @Prop() public readonly canClose: boolean | undefined;

    constructor() {
        super();
    }

    get isCloseable() {
        return this.canClose  !== undefined ? this.canClose : true;
    }

    get shouldShowLogo() {
        return this.showLogo !== undefined ? this.showLogo : true;
    }
    public close() {
        if (this.isCloseable) {
            // @ts-ignore
            this.$parent.close();
        } else {
            this.onClose();
        }
    }
    public save() {

    }
    @Emit('close')
    public onClose() {
        console.log('closing modal');
    }

}
